export default {
  title01: "Погода сейчас",
  title02: "24 часа",
  title03: "Прогноз на 10 дней",
  title04: "ИКВ",
  title05: "Смотреть всю информацию",
  title06: "ВОСХОД И ЗАХОД СОЛНЦА",
  title07: "ФАЗЫ ЛУНЫ",
  title08: "Следующее полнолуние",
  title09: "Следующее новолуние",
  title10: "ДЕНЬ",
  title11: "НОЧЬ",
  title12: "Восход солнца",
  title13: "Закат",
  title14: "Восход луны",
  title15: "Заход луны",
  title16: "Источник",
  title17: "Начать",
  title18: "Закончить",
  title19: "Использовать текущее местоположение",
  title20: "Искать город",
  title21: "Ощущается как ",
  title22: "В тени ощущается как",
  title23: "Сейчас",
  title24: "Сегодня",
  title25: "ВС",
  title26: "ПН",
  title27: "ВТ",
  title28: "СР",
  title29: "ЧТ",
  title30: "ПТ",
  title31: "СБ",
  title32: "Загрузка...",
  title33: "Сейчас",
  title34: "Почасовой прогноз",
  title35: "Ежедневный прогноз",
  title36: "Солнце и Луна",
  title37: "Качество воздуха",
  title38: "Для связи: xlf550402@gmail.com",
  title39: "Соглашение о конфиденциальности",
  title40: "Авторские права © comfortweather.com 2020 - 2026. Все права защищены.",
  title41: "Данные предоставлены",
  title42: "Макс.",
  title43: "Мин.",
  title44: "Принять",
  title45: "Спасибо, что пользуетесь ComfortWeather! Чтобы мы могли лучше защитить Ваши данные, ознакомьтесь с нашей  ",
  title46: "Политикой конфиденциальности",
  title47: " перед использованием.",
  title48: "",
  title49: "Для связи: xyjph123@gmail.com",
  title50: "Авторские права © 24hweather.com 2020 - 2026. Все права защищены.",
  title51:
    "Спасибо, что пользуетесь 24hweather! Чтобы лучше защитить ваши законные права и интересы, пожалуйста, внимательно прочитайте ",
  title52: "Ваше местоположение изменилось. Хотите обновить его?",
  title53: "Подтвердить",
  title54: "Отменить ",
  title55: "Назад",
  title56: "Новости",
  title57: "Погода обновляется...",
  title58: "Погода обновлена",
  title59: "Показать всё",
  title60: "Авторские права © mobi321.com 2020 - 2026. Все права защищены.",
  title61: "Вчера",
  title62: "Завтра",
  title63: "Прогноз на 15 дней",
  title64: "Подробности",
  title65: "Rahu Kaal",
  title66: "Советы на день",
  title67: "Советы на день",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Сложно высушить",
  title103: "Медленно сохнет",
  title104: "Хорошо сохнет",
  title105: "Быстро сохнет",
  title106: "Очень быстро сохнет",

  title107: "Не подходит",
  title108: "Умеренные условия",
  title109: "Хорошо для купания",
  title110: "Очень подходит",
  title111: "Идеальные условия",

  title112: "Благоприятные условия",
  title113: "Нейтральные условия",
  title114: "Небольшой риск",
  title115: "Повышенный риск",
  title116: "Очень высокий риск",

  title117: "Не подходит",
  title118: "Частично подходит",
  title119: "Хорошо",
  title120: "Очень подходит",
  title121: "Отличные условия",

  title122: "Очень сухие условия",
  title123: "Вероятна сухость",
  title124: "Небольшая сухость",
  title125: "Сухость маловероятна",
  title126: "Сухость крайне маловероятна",

  title127: "Не рекомендуется",
  title128: "Допустимо",
  title129: "Хороший день",
  title130: "Очень хорошие условия",
  title131: "Идеальные условия",
};
